const enrollmentRequestFixture = {
  data: {
    allEnrollments: {
      nodes: [
        {
          id: 1,
          approved: false,
          classroomByClassroomId: {
            id: 12,
            name: 'MÓDULO 1 CONHECIMENTOS BÁSICOS',
            slug: 'modulo-1-conhecimentos-basicos',
            materialsByClassroomId: {
              totalCount: 4,
            },
          },
        },
        {
          id: 2,
          approved: false,
          classroomByClassroomId: {
            id: 13,
            name: 'MÓDULO 2 FUNDAMENTOS DA DOCÊNCIA',
            slug: 'modulo-2-fundamentos-da-docencia',
            materialsByClassroomId: {
              totalCount: 4,
            },
          },
        },
        {
          id: 3,
          approved: false,
          classroomByClassroomId: {
            id: 14,
            name: 'MÓDULO 3 PRÁTICAS DE ENSINO (PRÉ ESCOLA)',
            slug: 'modulo-3-praticas-de-ensino-pre-escola',
            materialsByClassroomId: {
              totalCount: 4,
            },
          },
        },
      ],
    },
  },
};

export default enrollmentRequestFixture;
